export const stores = [
  {
    title: 'Sandton City',
    location: 'Johannesburg',
    regularOpenDays: 'Monday to Thursday:',
    regularOpenHours: '09h00-19h00',
    holidayOpenDays: 'Friday to Saturday:',
    holidayOpenHours: '09h00-20h00',
    weekendOpenDays: 'Sunday & Public Holidays:',
    weekendOpenHours: '09h00-18h00',
    image: '/assets/images/store/nav_sandton-city-store.webp',
    slug: 'sandton-city',
  },
  {
    title: 'Menlyn Park',
    location: 'Pretoria',
    regularOpenDays: 'Monday to Thursday:',
    regularOpenHours: '09h00-20h00',
    holidayOpenDays: 'Friday & Saturday:',
    holidayOpenHours: '09h00-21h00',
    weekendOpenDays: 'Sunday & Public Holidays:',
    weekendOpenHours: '09h00-18h00',
    image: '/assets/images/store/nav_menlyn-park-store.webp',
    slug: 'menlyn-maine',
  },
  {
    title: 'Gateway',
    location: 'Durban',
    regularOpenDays: 'Monday to Thursday:',
    regularOpenHours: '09h00-19h00',
    holidayOpenDays: 'Friday & Saturday:',
    holidayOpenHours: '09h00-21h00',
    weekendOpenDays: 'Sunday',
    weekendOpenHours: '09h00-18h00',
    image: '/assets/images/store/nav_gateway.webp',
    slug: 'gateway-durban',
  },
  {
    title: 'V&A Waterfront',
    location: 'Cape Town',
    regularOpenDays: 'Monday to Sunday',
    regularOpenHours: '09h00-21h00',
    holidayOpenDays: 'Public Holidays:',
    holidayOpenHours: '09h00-21h00',
    image: '/assets/images/store/nav_v&a-waterfront.webp',
    slug: 'v-and-a-store',
  },
];
